/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\global.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import setEmpty, { SET_EMPTY, UNSET_EMPTY } from '../actions/empty';
import { IS_LOADING, NOT_LOADING } from '../actions/loading';

export function empty(state = true, action) {
  if (action.type == SET_EMPTY) return true;
  if (action.type == UNSET_EMPTY) {
    return false;
  }
  return state;
}

export function loading(state = false, action) {
  if (action.type == IS_LOADING) {
    return true;
  } if (action.type == NOT_LOADING) {
    return false;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/global.js